import FrontendHttpClient from '@/utils/http-handler/frontend-http-client';
import useSWR from 'swr';
import { route } from 'nextjs-routes';
import { useBulkJobId } from './use-bulk-job-id';

/**
 * certPolicyCounts - The number of certs each policy/lob is on
 * certPolicyCountsAfterLobRemoval - The number of certs each policy/lob would be on after removing the requested lobs
 * longestDescOfOps - The length of the longest description of operations on any cert in this bulk edit
 */

/**
 * @param {object} params
 * @param {string[]} params.certIds
 * @param {string[]} params.lobsBeingRemovedIds
 */
export const useBulkPolicyCounts = ({ certIds, lobsBeingRemovedIds = [] }) => {
  const bulkJobId = useBulkJobId();

  /**
   */
  const { data, mutate, isValidating } = useSWR(
    bulkJobId
      ? [
          route({ pathname: '/api/v2/bulk-info/policy-counts' }),
          certIds,
          lobsBeingRemovedIds,
        ]
      : null,
    async ([url, _certIds, _lobsBeingRemovedIds]) => {
      const certIdsCount = _certIds?.length || 0;

      let requestBody = {
        bulkJobId,
        lobsBeingRemovedIds: _lobsBeingRemovedIds,
      };

      // If certIds exceed the limit, upload to S3
      if (certIdsCount > 25000) {
        try {
          // Get presigned URL for uploading certIds JSON
          const { data: uploadLinkData } = await FrontendHttpClient.post(
            '/api/v2/bulk_job_certificate/bulk/get-upload-link',
            {}
          );

          const { s3Key, presignedUrl } = uploadLinkData;

          // Upload certIds JSON to S3
          const certIdsJson = JSON.stringify(_certIds);
          await fetch(presignedUrl, {
            method: 'PUT',
            body: certIdsJson,
            headers: {
              'Content-Type': 'application/json',
            },
          });

          requestBody.certificateIdsS3Key = s3Key;
        } catch (error) {
          // If S3 upload fails, fall back to sending certIds directly
          // This might fail for very large arrays, but better than silent failure
          requestBody.certIds = _certIds;
        }
      } else {
        requestBody.certIds = _certIds;
      }

      const res = await FrontendHttpClient.post(url, requestBody);
      return res.data;
    }
  );

  return {
    ...data,
    bulkJobId,
    mutate,
    isValidating,
  };
};
